import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Button } from "@/components/ui/button";
import { Clock3, CheckCircle2 } from "lucide-react";

export default function SellerPending() {
  usePageMeta("Application Submitted", "Your NICEE seller account is pending approval.");
  const location = useLocation();
  const submitted = location.state?.submitted;

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-4 py-10">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-lg rounded-3xl bg-white p-10 text-center shadow-lift" data-testid="seller-pending-card">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brand/20 text-brand">
          {submitted ? <CheckCircle2 className="h-8 w-8" /> : <Clock3 className="h-8 w-8" />}
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-ink">
          {submitted ? "Application Submitted!" : "Pending Approval"}
        </h1>
        <p className="mt-3 text-ink-soft">
          Your NICEE Seller Account has been submitted successfully. Your account is
          <span className="font-semibold text-ink"> pending admin approval</span>. You'll be able to log in to the
          Seller Dashboard once the NICEE team approves your shop.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/seller/login">
            <Button className="rounded-full bg-brand text-ink hover:bg-brand-hover" data-testid="seller-pending-login">Go to Seller Login</Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="rounded-full">Back to NICEE</Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
